import imageProperties from '../lib/image-properties'

const createQuery = () => `
  ... on PaginatedListWidget {
    itemsPerPage
    totalItems
    items {
      title
      text
      images {
        hero_landscape_668 {
          ${imageProperties}
        }
      }
    }
  }
`

export default createQuery
